__turbopack_context__.v({
  "leaves": "Tree-module__Can00a__leaves",
  "sway": "Tree-module__Can00a__sway",
  "trunk": "Tree-module__Can00a__trunk",
});
